import { render, staticRenderFns } from "./behalf_vote_add.vue?vue&type=template&id=b0aefe54&scoped=true&"
import script from "./behalf_vote_add.vue?vue&type=script&lang=js&"
export * from "./behalf_vote_add.vue?vue&type=script&lang=js&"
import style0 from "./behalf_vote_add.vue?vue&type=style&index=0&id=b0aefe54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aefe54",
  null
  
)

export default component.exports